import { useContext, useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { notification } from 'antd';
import setAuthenticatedUser from 'src/modules/auth/setAuthenticatedUser';
import login from '@/api/auth/login.endpoint';
import { useRouter } from 'next/router';
import openAPIErrorNotification from '@/shared/APIErrorNotification/APIErrorNotification';

export default function useDuplicateLoginStep({ flowState, flowActions }) {
  const globalContext = useContext(GlobalContext);
  const router = useRouter();
  const { state, actions } = useCustomHook({
    defaultState: {
      loading: false,
      showForm: false,
    },
    actions: {
      duplicateLogin: async (values) => {
        actions.setState({ loading: true });
        try {
          const response = await login({
            login: flowState.studentData.selectedDuplicate,
            password: values.password,
            preventRedirectOnUnauthorized: true,
          });
          await setAuthenticatedUser({
            accessToken: response.token,
            context: globalContext,
          });

          router.push('/student/dashboard');
        } catch (error) {
          console.log(error);
          openAPIErrorNotification({
            title: 'Login error',
            description: [
              'The username or password is not correct.',
              "If you don't remember your username or password ask your teacher.",
            ],
          });

          actions.setState({
            loading: false,
          });
        }
      },
      goBack: () => {
        const newStudentData = { ...flowState.studentData };
        delete newStudentData.selectedDuplicate;
        flowActions.setStudentData(newStudentData);
        flowActions.setActiveStep('confirmPossibleDuplicate');
      },
    },
  });

  return { state, actions };
}
